export const ActionTypes = {
  GOAL_LOADING: "GET_GOAL_PROGRESS_LOADING",
  GOAL_ERROR: "GET_GOAL_PROGRESS_ERROR",
  GOAL_SUCCESS: "GET_GOAL_PROGRESS_SUCCESS",

  ACTION_LOADING: "GET_ACTION_PROGRESS_LOADING",
  ACTION_ERROR: "GET_ACTION_PROGRESS_ERROR",
  ACTION_SUCCESS: "GET_ACTION_PROGRESS_SUCCESS",
};
